import { useState } from "react";
import Modal from "@mui/material/Modal";
import Slide from "@mui/material/Slide";
import CloseIcon from "@mui/icons-material/Close";

export function AluminiCard({
  imageUrl, name, profession, location, alt, yearOfPassing
}) {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <div className="bg-white rounded-lg shadow hover:shadow-md transition-all duration-300 max-w-xs p-4 sm:p-5 transform hover:-translate-y-1">
        <div className="flex flex-col items-center text-center">
          <div
            className="w-20 h-20 mb-3 rounded-full overflow-hidden ring-2 ring-gray-100 cursor-pointer"
            onClick={handleOpenModal}
          >
            <img
              src={imageUrl || "/default-avatar.jpg"}
              alt={alt || "Profile picture"}
              className="w-full h-full object-cover"
            />
          </div>

          <h2
            className="text-xl font-semibold text-gray-900 mb-1 cursor-pointer hover:text-blue-600"
            onClick={handleOpenModal}
          >
            {name}
          </h2>
          <p className="text-xs text-pink-700 bg-pink-50 px-2 py-1 rounded-md mb-2">
            Batch of {yearOfPassing}
          </p>

          <div className="text-sm text-gray-700 flex items-center mb-1">
            <i className="fas fa-briefcase text-blue-500 mr-1"></i>
            {profession}
          </div>

          <div className="text-sm text-gray-500 flex items-center">
            <i className="fas fa-location-dot text-blue-500 mr-1"></i>
            {location}
          </div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={handleCloseModal}
        sx={{ display: "grid", placeItems: "center" }}
      >
        <Slide direction="down" in={showModal} timeout={500}>
          <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl mx-4">
            <div className="flex justify-between items-center p-6 border-b">
              <h2 className="text-2xl font-bold text-gray-900">Alumni Profile</h2>
              <button
                onClick={handleCloseModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <CloseIcon />
              </button>
            </div>

            <div className="p-6">
              <div className="flex flex-col md:flex-row gap-8">
                <div className="flex flex-shrink-0 justify-center items-center">
                  <div className="w-60 h-60 rounded-full overflow-hidden ring-4 ring-gray-100">
                    <img
                      src={imageUrl || "/default-avatar.jpg"}
                      alt={alt || "Profile picture"}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                <div className="flex-grow">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{name}</h3>
                  <p className="text-sm text-pink-700 bg-pink-50 px-3 py-1 rounded-full inline-block mb-4">
                    Batch of {yearOfPassing}
                  </p>

                  <div className="space-y-4">
                    <div className="flex items-center">
                      <i className="fas fa-briefcase text-blue-500 w-6"></i>
                      <span className="text-gray-700 ml-2">{profession}</span>
                    </div>

                    <div className="flex items-center">
                      <i className="fas fa-location-dot text-blue-500 w-6"></i>
                      <span className="text-gray-700 ml-2">{location}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slide>
      </Modal>
    </>
  );
}




